import type React from "react"
import { useTranslation } from "react-i18next"

import type { Meter } from "@/models/meter"
import { TextField } from "@/nzds/inputs/text-field"

import { Autocomplete } from "@mui/material"

interface MeterCodeFieldProps {
  getOptionLabel?: (meter: Meter) => string
  meters: readonly Meter[]
  onChange: (meter: Meter | null) => void
  value: Meter | null
}

const meterCodeLabel = (meter: Meter): string => meter.meterCode

export const MeterCodeField: React.FC<MeterCodeFieldProps> = ({
  getOptionLabel = meterCodeLabel,
  meters,
  onChange,
  value,
}) => {
  const { t } = useTranslation("common")

  return (
    <Autocomplete
      getOptionLabel={(meter) => getOptionLabel(meter)}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      onChange={(_event, meter) => {
        onChange(meter)
      }}
      options={[...meters]}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("fields.meterCode.title")}
          size="small"
          sx={{ width: 240 }}
        />
      )}
      value={value}
    />
  )
}
